import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  banner: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 12,
    width: "100%",
    padding: "10px 16px",
    marginBottom: 20,
    borderRadius: 6,
    backgroundColor: "rgba(0, 0, 0, 0.03)",
    border: "1px solid rgba(0, 0, 0, 0.08)",
  },
  bannerStale: {
    backgroundColor: "rgba(255, 152, 0, 0.08)",
    borderColor: "rgba(255, 152, 0, 0.35)",
  },
  text: {
    color: theme.palette.text.primary,
    flex: 1,
    minWidth: 200,
  },
  hint: {
    color: theme.palette.text.secondary,
  },
}));

export default useStyles;
